import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs/internal/Observable";
import { catchError } from "rxjs/internal/operators/catchError";
import { MascaraCnaePermitido } from "src/app/model/mascara-cnae-permitido.model";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { CodigoCnaeDTO } from "./pesquisa/cnae-permitido-pesquisa.component";
import { useCache } from "@bndes/bndes-ux4/bndes-angular-utils";

export interface MascaraDto {
    id?: number;
    mascara: string;
}

export interface NovoCnaePermitidoDTO {
    mascara: string;
    dataInicioValidade: Date;
    tipoOperacao: string;
    objetivoFinanciamento: string;
}

export interface CnaesPermitidosDTO {
    cnaesPermitidosDTO: NovoCnaePermitidoDTO[];
}

@Injectable({
    providedIn: 'root'
})
export class CnaePermitidoService extends FgiBackEndService<MascaraCnaePermitido>{

    getNewEntity(): MascaraCnaePermitido {
        return new MascaraCnaePermitido();
    }

    protected getResourceURL(): string {
        return 'front/cnaes-permitidos';
    }

    getMascaras(): any{
        const options = blockUi();
        return this.http.get(`${this.BASE_URL}/todasMascaras`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<MascaraDto>>;
    }

    getCnaesPermitidos(params?: any): any {
        return this.http.get(`${this.BASE_URL}/`, {params: params}).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<MascaraCnaePermitido>>;
    }

    encerrarVigenciaCnaePermissao(ideCnae?: number, justificativa?: string): any {
        const options = blockUi();
        return this.http.post(`${this.BASE_URL}/encerrar/${ideCnae}`, justificativa, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<MascaraCnaePermitido>>;
    }

    getCodigosCnae(): any{
        const options = blockUi();
        return this.http.get(`${this.BASE_URL}/todosCodigosCnae`, useCache()).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<CodigoCnaeDTO>>;
    }

    salvar(ideTranche: number,  dados: CnaesPermitidosDTO) {
        const options = blockUi();
        return this.http.post(`${this.BASE_URL}/salvar/${ideTranche}`, dados, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }

}
